blue.ready('listing', '.mixitup--pagination', container => {
	const items = container.querySelector('.item')
	let mixerMain = mixitup(container, {
		selectors: {
			target: '.item'
		},
  	animation: {
        duration: 250,
        nudge: false,
        reverseOut: false,
        effects: "fade scale(0.01) translateZ(-100px) stagger(40ms)"
    },
		callbacks: {
			onPaginateStart() {
				setTimeout(() => {
					window.scrollTo({
						top: items.offsetTop - 40,
						behavior: 'smooth'
					})
				})
			},
		},
		pagination: {
			limit: 5,
			hidePageListIfSinglePage: true,
			maintainActivePage: true
		},
		templates: {
			pager: '<button type="button" class="pagination-button ${classNames}" data-page="${pageNumber}">${pageNumber}</button>',
			pagerPrev: '<button type="button" class="pagination-button ${classNames}" data-page="prev"></button>',
			pagerNext: '<button type="button" class="pagination-button ${classNames}" data-page="next"></button>',
			pagerTruncationMarker: '<span class="pagination-trunc ${classNames}">&hellip;</span>'
		}
	});
})